export default class PreventEventObserver {
  _target = window;

  _eventTypes = [ 'keydown' ];

  _capture = true;

  constructor(eventTypes, target, capture) {
    this._target = target;
    this._eventTypes = eventTypes;
    this._capture = capture;
  }

  preventHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  observe() {
    this._eventTypes.forEach((type) => {
      this._target.addEventListener(type, this.preventHandler, this._capture);
    });
  }

  unobserve() {
    this._eventTypes.forEach((type) => {
      this._target.removeEventListener(type, this.preventHandler, this._capture);
    });
  }
}
